import axios from 'axios'

// console.log(process.env.REACT_APP_SERVER_ADDR);
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_ADDR,
  withCredentials: true,
})

export default axiosInstance
